import React from "react";
import ProductHomePage from "./components/template/productHomePage";

function App() {
  return (
    <div className="">
      <ProductHomePage />
    </div>
  );
}

export default App;
